import { render, staticRenderFns } from "./MinuteTypePage.vue?vue&type=template&id=03f652c9&scoped=true&"
import script from "./MinuteTypePage.vue?vue&type=script&lang=ts&"
export * from "./MinuteTypePage.vue?vue&type=script&lang=ts&"
import style0 from "./MinuteTypePage.vue?vue&type=style&index=0&id=03f652c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03f652c9",
  null
  
)

export default component.exports